import {getAuthenticatedApolloClient} from '../../../../../../lib'

export const aOpenFile = (fileId: string) => async (): Promise<any> => {
  const client = getAuthenticatedApolloClient()
  return client.Documents.fetch({fileId}).then((response: any) => {
    const blob = response.responseData
    const fileURL = URL.createObjectURL(blob)
    const newTab = window.open(fileURL)
    return {
      status: !(!newTab || newTab.closed || typeof newTab.closed === 'undefined')
        ? 'success'
        : 'failed', // permission denied to open new tab
    }
  })
}
